// extracted by mini-css-extract-plugin
export default {"contactWrapper":"Contact_contactWrapper__GGAnJ","column":"Contact_column__xGRcI","right":"Contact_right__xex++","companyName":"Contact_companyName__dMllk"};